export default __webpack_public_path__ + "static/media/elder-gods-landing.3acec472.png";